import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = {
  key: 0,
  class: "login-title"
}
const _hoisted_3 = { class: "login-form" }

import studentDialog from "./studentDialog.vue"
import { ref, reactive, onMounted } from 'vue';
import { bindUserAccount, getArea, getUserInfo, getDict } from "@/api/common.js"
import { ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'studentDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    },
    isPerson: {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const userInfo = store.state.userInfo
const props = __props
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    studentName: '',
    userAccount: '',
    province: ''
})
const treeColumn = ref([])
const treeProps = {
    label: 'areaLabel',
    value: 'areaCode'
}
const gradeList = ref([])
const emitList = __emit
const formRules = {
    province: [
        {
            message: '请选择学校所在地区',
            required: true
        }
    ]
}

function bindStudent() {
    loginRef.value.validate(valid => {
        if (valid) {
            console.log(formData.value)
            let params = {
                "areaCode": formData.value.province[2],
                "cityCode": formData.value.province[1],
                "provinceCode": formData.value.province[0],
                "studentName": formData.value.studentName || '',
                "userAccount": formData.value.userAccount || '',
                "grade": formData.value.grade || '',
            }
            bindUserAccount(params).then(res => {
                console.log(res)
                ElMessage.success('绑定成功')
                getUserInfo().then(res => {
                    store.dispatch('setLogin', res.data);
                    store.dispatch('setGradeTerm', res.data)
                    if (res.data.firstLogin) {
                        ElMessageBox.confirm(
                            '赠送21天会员，您已领取成功',
                            '提示',
                            {
                                confirmButtonText: '知道了',
                                cancelButtonText: '取消',
                                type: 'warning',
                                showClose: false,
                                showCancelButton: false
                            }
                        ).then(() => {
                            emitList('close')
                        })
                    } else {
                        emitList('close')
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function getAreaList() {
    getArea().then(res => {
        treeColumn.value = res.data;
    })
}

function closeEvent() {
    emitList('close')
}

function getDictList() {
    getDict({
        dicCode: 'dd_grade'
    }).then(res => {
        gradeList.value = res.data || []
    })
}

onMounted(() => {
    getAreaList()
    getDictList()
    if (userInfo.userName) {
        formData.value.studentName = userInfo.userName
    }
    if (userInfo.userAccount) {
        formData.value.userAccount = userInfo.userAccount
    }
    if (userInfo.grade) {
        formData.value.grade = userInfo.grade
    }
    let arr = []
    arr.push(userInfo.provinceCode || '')
    arr.push(userInfo.cityCode || '')
    arr.push(userInfo.areaCode || '')
    formData.value.province = arr.every(item => {
        return item ? true : false
    }) ? arr : []
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogShow).value = $event)),
    width: "360px",
    title: "请完善学生信息",
    center: "",
    onClose: closeEvent,
    "close-on-click-modal": false,
    "show-close": __props.isPerson
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!__props.isPerson)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "您的账号尚未完善学生信息"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            ref_key: "loginRef",
            ref: loginRef,
            model: formData.value,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "studentName" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.studentName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.studentName) = $event)),
                            placeholder: "请输入学生姓名"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "userAccount" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.userAccount,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.userAccount) = $event)),
                            placeholder: "请输入学生学籍号"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "grade" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.grade,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.grade) = $event)),
                            placeholder: "请输入当前年级"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradeList.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.dicItemCode,
                                  label: item.dicItemName,
                                  value: item.dicItemCode
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "province" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_cascader, {
                            style: {"width":"100%"},
                            modelValue: formData.value.province,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.province) = $event)),
                            options: treeColumn.value,
                            props: treeProps,
                            placeholder: "请选择学校所在地区"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"width":"100%"},
            color: "#ef8b25",
            class: "footer-btn1",
            onClick: bindStudent
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("确认绑定")
            ])),
            _: 1,
            __: [5]
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "show-close"]))
}
}

})